module.exports = function ($) {
  'use strict';

  function getCookie(name) {
    return `; ${document.cookie}`.split(`; ${name}=`).pop().split(';')[0];
  }

  function initHeaderLangChanger() {
    var $headerLang = $('.header-lang-changer'),
      $wrapper = $('.lang-changer-wrapper'),
      $arrow = $('.header-dropdown-arrow', $headerLang),
      $dd = $('.dropdown-menu', $headerLang),
      $option = $('a', $dd),
      $langChooser = $('.set-lang'),
      $originalLang = $('.dropdown-menu > li[class="active"] > a').data(
        'lang',
      );

    $wrapper.on('click', function () {
      $arrow.toggleClass('is-active');
    });

    $option.on('click', function () {
      const lang = $(this).data('lang');

      $.post('/setlang/', {
        language: lang,
      })
        .done(function () {
          // Locale in url if present prevents the page from being localized to the new chosen language
          const hrefWithoutLocale = location.href.replace(
            `/${$originalLang}/`,
            '/',
          );
          if (hrefWithoutLocale !== location.href) {
            location.replace(hrefWithoutLocale);
          } else {
            location.reload();
          }
        })
        .fail(function (res) {
          if (res.status === 200 && lang === getCookie('memrise_lang')) {
            location.reload();
          }
          throw new Error('Failed to change language');
        });
    });

    $(document).click(function (e) {
      var target = e.target;

      if (
        $arrow.hasClass('is-active') &&
        !$(target).is($('a', $langChooser)) &&
        !$(target).is($wrapper) &&
        !$(target).is($dd) &&
        !$(target).is($option.parent())
      ) {
        $arrow.removeClass('is-active');
      }
    });
  }
  initHeaderLangChanger();
};
